<template>
  <div v-if="auction.auctionStatus == 'OPEN'">
    <div class="flex">
      <div class="flex-grow">
        <div class="">
          {{ $t("auction.will_close_at") }}
        </div>
        <div class="text-lg font-bold mb-2">
          {{ dateUtils.formatWithSeconds(auction.effectiveEndAt) }}
        </div>

        <div>{{ $t("auction.opening_date") }}:<br class="lg:hidden"> <b>{{ dateUtils.formatWithSeconds(auction.startAt) }}</b></div>
      </div>
      <div class="">
        <CircleCountdown
          :start="auction.startAt"
          :end="auction.effectiveEndAt"
        />
      </div>
    </div>
  </div>
  <div v-else-if="auction.auctionStatus == 'REDISTRIBUTING_1' || auction.auctionStatus == 'REDISTRIBUTING_2'">
    <div class="flex">
      <div class="flex-grow">
        <div>
          {{ $t("auction.closed_at") }}
        </div>
        <div class="text-lg font-bold mb-2">
          {{ dateUtils.formatWithSeconds(auction.effectiveEndAt) }}
        </div>
        <div>
          {{ $t("auction.redistribution_will_close_at") }}
        </div>
        <div class="text-lg font-bold mb-2">
          {{ dateUtils.formatWithSeconds(auction.redistributeEndAt) }}
        </div>
      </div>
      <div class="">
        <CircleCountdown
          :start="auction.effectiveEndAt"
          :end="auction.redistributeEndAt"
        />
      </div>
    </div>
  </div>
  <div v-else-if="auction.auctionStatus == 'CLOSED'">
    <div>
      {{ $t("auction.closed_at") }}
    </div>
    <div class="text-lg font-bold mb-2">
      {{ dateUtils.formatWithSeconds(auction.effectiveEndAt) }}
    </div>
  </div>
  <div v-else>
    <div class="">
      {{ $t("auction.will_open_at") }}
    </div>
    <div class="text-lg font-bold mb-2">
      {{ dateUtils.formatWithSeconds(auction.startAt) }}
    </div>
  </div>
</template>

<script setup>
import CircleCountdown from '@/components/CircleCountdown.vue';
import dateUtils from '@/services/date-utils';

const props = defineProps({
    auction: {
        type: Object,
        required: true
    },
    outbidLotUuid: {
        type: String,
        required: false,
        default: null
    }
})
</script>